import { Card, CardContent } from "@mui/material";
import CardHeader from "@mui/material/CardHeader";

export const InfoCard = ({ header, children, dataAutomation }: {
  header?: string,
  children: JSX.Element | JSX.Element[],
  dataAutomation?: {
    header: string
  }
}) => (<Card>
  <CardHeader
    data-automation={dataAutomation?.header ?? 'infocard-header'}
    title={header}
    titleTypographyProps={{
      variant: "subtitle1",
      fontSize: "18px"
    }}
    sx={{
      backgroundColor: "primary.main",
      color: "primary.contrastText"
    }} />
  <CardContent>
    {children}
  </CardContent>
</Card>);